export { default } from "./MinusIcon";
